import { makeStyles } from "tss-react/mui"
import { Box, Stack, Skeleton } from "@mui/material"

const useStyles = makeStyles()(() => ({
    wrap: {
        width: "100%",
    },
    box: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "4rem",
    },

    detailBlock: {
        display: "flex",
        flexDirection: "column",
        gap: ".375rem",
    },
}))

const DETAIL_ROWS = 6

export function ResourceDetailsDialogSkeleton() {
    const { classes } = useStyles()

    return (
        <Stack gap="1rem" className={classes.wrap}>
            <Skeleton variant="text" height={60} />
            <Box className={classes.box}>
                <Stack gap="2rem">
                    {Array.from({ length: DETAIL_ROWS }).map((_, i) => (
                        <Box key={i} className={classes.detailBlock}>
                            <Skeleton variant="text" width="60%" height="1.5rem" />
                            <Skeleton variant="text" height="1.25rem" />
                        </Box>
                    ))}
                </Stack>
                <Skeleton variant="rectangular" width="100%" height="15rem" />
            </Box>
        </Stack>
    )
}
